import { gql } from "@apollo/client"
import { useQuery } from "@oysterhr/core"

export const ASPECT_COMPANY_FRAGMENT = gql`
  fragment AspectCompanyFragment on Company {
    id
    avatarUrl
    createdAt
    name
    timeOffManagementTool
    countryCode
    isClient
    isCustomer
    modeName
    customer {
      id
      name
    }
  }
`

const BASE_GET_USER_ASPECTS = gql`
  query BaseGetUserAspects {
    aspects {
      ... on StaffAspect {
        id
        type
        company {
          ...AspectCompanyFragment
        }
        authorizations {
          actions
        }
      }
      ... on CompanyAspect {
        id
        type
        company {
          ...AspectCompanyFragment
        }
        authorizations {
          actions
        }
      }
      ... on ContractAspect {
        id
        type
        company {
          ...AspectCompanyFragment
        }
        engagement {
          id
          role
          state
          contract {
            id
          }
          isPayrollTeamMember
          countryCode
        }
        authorizations {
          actions
        }
      }
      ... on EmploymentAspect {
        id
        type
        company {
          ...AspectCompanyFragment
        }
        engagement {
          id
          role
          state
          contract {
            id
          }
          isPayrollTeamMember
          countryCode
        }
        authorizations {
          actions
        }
      }
    }
  }
  ${ASPECT_COMPANY_FRAGMENT}
`

export const useAspects = ({ skip }: { skip?: boolean }) => {
  return useQuery(BASE_GET_USER_ASPECTS, { skip, ignoredErrorCodes: ["403", "429"] })
}
